import React from "react";
import { ShimmerBlock } from "../common/Skeleton";

const GroupCardSkeleton: React.FC = () => (
  <div className="rounded-card border border-border-secondary bg-surface p-5 shadow-soft sm:p-6">
    <div className="mb-4 flex items-center gap-3">
      <ShimmerBlock className="h-[42px] w-[42px] rounded-lg" />
      <div className="flex-1 space-y-2">
        <ShimmerBlock className="h-4 w-32" />
        <ShimmerBlock className="h-3 w-24" />
      </div>
      <ShimmerBlock className="h-8 w-8 rounded-button" />
    </div>
    <div className="flex flex-wrap gap-2">
      {Array.from({ length: 5 }).map((_, i) => (
        <ShimmerBlock key={i} className="h-7 w-24 rounded-full" />
      ))}
    </div>
  </div>
);

/** Figma group-card grid loading state (with data / without data share this). */
export const ConfigsPanelSkeleton: React.FC = () => (
  <div
    className="grid grid-cols-1 gap-4 sm:gap-5 lg:grid-cols-2"
    aria-busy="true"
    aria-label="Loading master configs"
  >
    {Array.from({ length: 4 }).map((_, i) => (
      <GroupCardSkeleton key={i} />
    ))}
  </div>
);

/** Back-compat export (legacy table skeleton replaced by card skeleton). */
export const ConfigsTableContentSkeleton: React.FC = ConfigsPanelSkeleton;
